import React from 'react';
// @ts-ignore
import png from './ellipse.png';

import s from './GreySpinner.module.scss';

export const GreySpinner = () => <img src={png} className={s.spinner} />;
